module.exports = __webpack_public_path__ + "static/media/Logo.e9cc399a.svg";